import type { ContractBulkPatch, CreateContractInput, DeleteRecordsInput, UpdateContractInput } from '@shared/types';
import { showUndoToastForLastAction } from '@renderer/app/undo/undo-toast';
import { getDesktopApi } from '@renderer/lib/desktop-api';

export async function listContracts() {
  return getDesktopApi().contracts.listContracts();
}

export async function getContractById(contractId: string) {
  return getDesktopApi().contracts.getContractById(contractId);
}

export async function deleteContracts(payload: DeleteRecordsInput) {
  const result = await getDesktopApi().contracts.deleteContracts(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function listDeletedContracts() {
  return getDesktopApi().contracts.listDeletedContracts();
}

export async function restoreContracts(payload: DeleteRecordsInput) {
  return getDesktopApi().contracts.restoreContracts(payload);
}

export async function purgeContracts(payload: DeleteRecordsInput) {
  return getDesktopApi().contracts.purgeContracts(payload);
}

export async function createContract(payload: CreateContractInput) {
  return getDesktopApi().contracts.createContract(payload);
}

export async function updateContract(payload: UpdateContractInput) {
  const result = await getDesktopApi().contracts.updateContract(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function applyBulkContractPatch(payload: ContractBulkPatch) {
  const result = await getDesktopApi().contracts.applyBulkPatch(payload);
  void showUndoToastForLastAction();
  return result;
}
